import React from 'react';
import { Helmet } from 'react-helmet';
import { styled } from 'react-free-style';
import { Link } from 'react-router-dom';

/**
 * Full-page fallback for the project-detail route.
 *
 * Used in two situations:
 *   1. The project record no longer exists (API 404 / "no record").
 *   2. The project record could not be loaded at all (5xx / network / parse).
 *
 * Both cases render the same shell for a uniform UX; only the copy and the
 * optional document title differ. There is intentionally no retry button here
 * - a repeatable failure would just loop the user through the same blank
 * screen, so we send them back to the homepage instead.
 */
const ProjectNotFound = ({
  styles,
  code = '404',
  title = 'Project not found',
  message = 'This project may have been deleted, or the link is no longer valid.',
  backTo = '/',
  backLabel = 'Back to homepage',
  documentTitle = 'PROJECT NOT FOUND',
}) => {
  return (
    <div className={styles.container}>
      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>

      <div className={styles.content}>
        <div className={styles.title}>{code}</div>
        <div className={styles.subTitle}>{title}</div>
        {message && <div className={styles.message}>{message}</div>}
        <Link className={styles.backLink} to={backTo}>
          {backLabel}
        </Link>
      </div>
    </div>
  );
};

const withStyles = styled({
  container: {
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '520px',
    padding: '0 20px',
  },
  title: {
    fontSize: '90px',
    fontWeight: 'bold',
  },
  subTitle: {
    fontSize: '18px',
  },
  message: {
    fontSize: '14px',
    color: '#555',
    marginTop: '12px',
  },
  backLink: {
    marginTop: '20px',
    fontSize: '18px',
  },
});

export default withStyles(ProjectNotFound);
